export const Comet = `
			<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   version="1.1"
   id="Capa_1"
   class="asteroid"
   x="0px"
   y="0px"
   viewBox="0 0 500 500"
   xml:space="preserve"
   inkscape:version="0.91 r13725"
   sodipodi:docname="asteroid-custom.svg"
   height="100%"
   width="100%"><metadata
     id="metadata3707"><rdf:RDF><cc:Work
         rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" /></cc:Work></rdf:RDF></metadata><defs
     id="defs3705" /><sodipodi:namedview
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1"
     objecttolerance="10"
     gridtolerance="10"
     guidetolerance="10"
     inkscape:pageopacity="0"
     inkscape:pageshadow="2"
     inkscape:window-width="1920"
     inkscape:window-height="1032"
     id="namedview3703"
     showgrid="false"
     inkscape:zoom="1.0193006"
     inkscape:cx="329.54589"
     inkscape:cy="183.30621"
     inkscape:window-x="0"
     inkscape:window-y="0"
     inkscape:window-maximized="1"
     inkscape:current-layer="g3669" /><g
     id="g3669"
     transform="matrix(0.70710679,0.70710678,-0.70710678,0.70710679,225.29991,-32.443155)"><circle
       style="fill:#edc148"
       cx="315.03101"
       cy="280.90799"
       r="65.997002"
       id="circle3671" /><g
       id="g3673"><path
         class="asteroid-force"
         style="fill:#b3b3b3"
         d="m 315.031,381.358 c -25.735,0 -51.47,-9.796 -71.062,-29.388 L 97.606,205.606 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 146.364,146.364 c 34.115,34.115 89.624,34.115 123.739,0 34.115,-34.115 34.115,-89.625 0,-123.739 l -80.602,-80.602 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 80.602,80.602 c 39.184,39.184 39.184,102.94 0,142.124 -19.592,19.591 -45.327,29.387 -71.062,29.387 z"
         id="path3675"
         inkscape:connector-curvature="0" /><path
         class="asteroid-stripe"
         style="fill:#b3b3b3"
         d="m 276.502,115.946 c -1.664,0 -3.327,-0.635 -4.596,-1.904 L 230.538,72.674 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 41.368,41.368 c 2.539,2.539 2.539,6.654 0,9.192 -1.269,1.27 -2.933,1.904 -4.596,1.904 z"
         id="path3677"
         inkscape:connector-curvature="0" /><g
         id="g3679"><path
           class="asteroid-stripe"
           style="fill:#b3b3b3"
           d="m 45.7,97.622 c -1.664,0 -3.327,-0.635 -4.596,-1.904 l -39.2,-39.2 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 39.2,39.2 c 2.539,2.539 2.539,6.654 0,9.192 -1.269,1.269 -2.932,1.904 -4.596,1.904 z"
           id="path3681"
           inkscape:connector-curvature="0" /><path
           class="asteroid-stripe"
           style="fill:#b3b3b3"
           d="m 215.869,267.791 c -1.664,0 -3.327,-0.635 -4.596,-1.904 L 55.903,110.517 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 155.37,155.37 c 2.539,2.539 2.539,6.654 0,9.192 -1.269,1.269 -2.932,1.904 -4.596,1.904 z"
           id="path3683"
           inkscape:connector-curvature="0" /><path
           class="asteroid-stripe"
           style="fill:#b3b3b3"
           d="m 207.915,180.292 c -1.664,0 -3.327,-0.635 -4.596,-1.904 L 120.591,95.66 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 82.728,82.728 c 2.539,2.539 2.539,6.654 0,9.192 -1.269,1.269 -2.932,1.904 -4.596,1.904 z"
           id="path3685"
           inkscape:connector-curvature="0" /><path
           class="asteroid-stripe"
           style="fill:#b3b3b3"
           d="m 246.096,218.473 c -1.664,0 -3.327,-0.635 -4.596,-1.904 l -18.03,-18.03 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 18.03,18.03 c 2.539,2.539 2.539,6.654 0,9.192 -1.269,1.269 -2.932,1.904 -4.596,1.904 z"
           id="path3687"
           inkscape:connector-curvature="0" /><path
           class="asteroid-stripe"
           style="fill:#b3b3b3"
           d="m 214.809,107.64 c -1.664,0 -3.327,-0.635 -4.596,-1.904 L 149.696,45.219 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 60.517,60.517 c 2.539,2.539 2.539,6.654 0,9.192 -1.269,1.269 -2.933,1.904 -4.596,1.904 z"
           id="path3689"
           inkscape:connector-curvature="0" /><path
           class="asteroid-stripe"
           style="fill:#b3b3b3"
           d="m 295.415,188.246 c -1.664,0 -3.327,-0.635 -4.596,-1.904 l -59.394,-59.394 c -2.539,-2.539 -2.539,-6.654 0,-9.192 2.538,-2.538 6.654,-2.538 9.192,0 l 59.394,59.394 c 2.539,2.539 2.539,6.654 0,9.192 -1.269,1.269 -2.933,1.904 -4.596,1.904 z"
           id="path3691"
           inkscape:connector-curvature="0" /></g></g><circle
       style="fill:#b2863f"
       cx="291.91599"
       cy="262.98199"
       r="12.749"
       id="circle3693"
       class="layout-comet-circle" /><circle
       style="fill:#b2863f"
       cx="343.67001"
       cy="294.56699"
       r="19.412001"
       id="circle3695"
       class="layout-comet-circle" /><path
       style="fill:#b2863f"
       d="m 288.915,312.981 c -0.42,0 -0.85,-0.04 -1.27,-0.13 -0.41,-0.08 -0.82,-0.21 -1.21,-0.37 -0.4,-0.16 -0.77,-0.36 -1.13,-0.6 -0.35,-0.23 -0.69,-0.51 -0.99,-0.8 -0.3,-0.3 -0.57,-0.64 -0.8,-0.99 -0.24,-0.36 -0.44,-0.73 -0.6,-1.13 -0.16,-0.39 -0.29,-0.8 -0.37,-1.21 -0.09,-0.42 -0.13,-0.85 -0.13,-1.27 0,-0.43 0.04,-0.85 0.13,-1.27 0.08,-0.42 0.21,-0.83 0.37,-1.22 0.16,-0.39 0.36,-0.77 0.6,-1.12 0.23,-0.36 0.5,-0.69 0.8,-0.99 0.3,-0.3 0.64,-0.57 0.99,-0.81 0.36,-0.23 0.73,-0.43 1.13,-0.59 0.39,-0.17 0.8,-0.29 1.21,-0.37 2.11,-0.43 4.36,0.26 5.87,1.77 0.3,0.3 0.57,0.63 0.81,0.99 0.23,0.35 0.43,0.73 0.59,1.12 0.17,0.39 0.29,0.8 0.37,1.22 0.09,0.42 0.13,0.84 0.13,1.27 0,0.42 -0.04,0.85 -0.13,1.27 -0.08,0.41 -0.2,0.82 -0.37,1.21 -0.16,0.4 -0.36,0.77 -0.59,1.13 -0.24,0.35 -0.51,0.69 -0.81,0.99 -1.21,1.2 -2.89,1.9 -4.6,1.9 z"
       id="path3697"
       inkscape:connector-curvature="0"
       class="layout-comet-circle" /><path
       style="fill:#b2863f"
       d="m 335.415,254.481 c -1.71,0 -3.39,-0.69 -4.6,-1.9 -0.3,-0.3 -0.57,-0.63 -0.81,-0.99 -0.23,-0.35 -0.43,-0.73 -0.59,-1.12 -0.17,-0.4 -0.29,-0.8 -0.37,-1.22 -0.09,-0.42 -0.13,-0.85 -0.13,-1.27 0,-1.71 0.69,-3.38 1.9,-4.59 0.3,-0.3 0.63,-0.58 0.99,-0.81 0.35,-0.24 0.73,-0.44 1.12,-0.6 0.4,-0.16 0.8,-0.29 1.22,-0.37 2.11,-0.42 4.36,0.27 5.86,1.78 1.22,1.2 1.91,2.88 1.91,4.59 0,0.42 -0.04,0.85 -0.13,1.27 -0.08,0.42 -0.21,0.82 -0.37,1.22 -0.16,0.39 -0.36,0.77 -0.6,1.12 -0.23,0.36 -0.51,0.69 -0.81,0.99 -1.21,1.21 -2.88,1.9 -4.59,1.9 z"
       id="path3699"
       inkscape:connector-curvature="0"
       class="layout-comet-circle" /><path
       style="fill:#b2863f"
       d="m 311.415,327.981 c -1.71,0 -3.39,-0.7 -4.6,-1.91 -1.21,-1.2 -1.9,-2.88 -1.9,-4.59 0,-1.71 0.69,-3.39 1.9,-4.6 1.21,-1.21 2.89,-1.9 4.6,-1.9 1.71,0 3.39,0.69 4.6,1.9 1.21,1.21 1.9,2.89 1.9,4.6 0,1.71 -0.69,3.38 -1.9,4.59 -1.21,1.21 -2.89,1.91 -4.6,1.91 z"
       id="path3701"
       inkscape:connector-curvature="0"
       class="layout-comet-circle" /></g></svg>
		`;


// WEBPACK FOOTER //
// ./src/Comet.js